import { useState, useEffect, useCallback } from 'react';
import { customerService } from '../services/api';
import { Customer } from '../types/mold';

export const useCustomers = () => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await customerService.getCustomers();
      setCustomers(response.data);
    } catch (err) {
      setError('Failed to fetch customers');
    } finally {
      setLoading(false);
    }
  }, []);

  const createCustomer = useCallback(async (data: { name: string; code: string; isActive: boolean }) => {
    try {
      await customerService.createCustomer(data);
      fetchCustomers(); // Refresh the customer list
    } catch (err) {
      setError('Failed to create customer');
    }
  }, [fetchCustomers]);

  const updateCustomer = useCallback(async (id: number, data: { name?: string; code?: string; isActive?: boolean }) => {
    try {
      await customerService.updateCustomer(id, data);
      fetchCustomers(); // Refresh the customer list
    } catch (err) {
      setError('Failed to update customer');
    }
  }, [fetchCustomers]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return { customers, loading, error, retry: fetchCustomers, fetchCustomers, createCustomer, updateCustomer };
};
